<template>
    <div v-if="user"
         class="currentUser">
        <a :href="profileUrl"
           target="_blank"><img :src="pictureUrl" /></a>
        Logged in as <a :href="profileUrl"
                        target="_blank">{{ name }}</a>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { getUserName } from 'wdm-common/Users';

export default {
    computed: {
        ...mapState(['user']),

        name() {
            return getUserName(this.user);
        },

        profileUrl() {
            return 'https://www.facebook.com/profile.php?id=' + this.user.userId;
        },

        pictureUrl() {
            if (this.user.pictureUrl) {
                return this.user.pictureUrl;
            }
            return 'https://graph.facebook.com/v2.2/' + this.user.userId + '/picture';
        },
    },
};
</script>
